import LegalPage from "./LegalPage";

export default function Refunds() {
  return (
    <LegalPage
      title="Refund Policy"
      subtitle="Our promise to your family"
      lastUpdated="February 14, 2026"
    >
      <p>
        We want your family to love Plate Buddies. If something arrives damaged or you simply change your
        mind on an unopened kit, here's exactly how we handle it.
      </p>

      <h2>30-day refund window</h2>
      <p>
        You may request a full refund within <strong>30 days of delivery</strong> for any{" "}
        <strong>unopened, factory-sealed</strong> Plate Buddies kit (Starter Kit or Premium Meal Planning
        System). Once the seal is broken or the box has been used, the kit is no longer eligible for
        refund.
      </p>
      <p>
        After 30 days from delivery, all sales are final unless required otherwise by law.
      </p>

      <h2>Custom Buddy Prints — non-refundable</h2>
      <p>
        Because every Custom Buddy Print is personalized and made to order based on your child's AI
        creation, <strong>Custom Buddy Prints are non-refundable</strong>. If your print arrives damaged
        in transit or with a manufacturing defect, we'll replace it at no charge — see the next section.
      </p>

      <h2>Damaged or defective items</h2>
      <p>
        If your order arrives damaged or defective, email us within 14 days of delivery at{" "}
        <a href="mailto:hello@platebuddies.com">hello@platebuddies.com</a> with:
      </p>
      <ul>
        <li>Your order email or order number</li>
        <li>A photo of the issue</li>
      </ul>
      <p>
        For verified defects we will <strong>cover the return shipping</strong> and either send a
        replacement or issue a full refund — your choice.
      </p>

      <h2>Return shipping (non-defect returns)</h2>
      <p>
        For unopened-kit returns inside the 30-day window, the customer is responsible for return
        shipping costs. We recommend using a tracked service. Once the item arrives back at our studio in
        unopened condition, we issue the refund within 5 business days.
      </p>

      <h2>How to start a return</h2>
      <ol>
        <li>Email <a href="mailto:hello@platebuddies.com">hello@platebuddies.com</a> with the subject line "Return Request" and your order email or order number.</li>
        <li>We'll respond within 2 business days with a return address and instructions.</li>
        <li>Ship the item back in its original packaging using a tracked carrier.</li>
        <li>Once we receive and inspect the item, we issue your refund to the original payment method within 5 business days. Banks may take an additional 5–10 days to post the credit.</li>
      </ol>

      <h2>Cancellations</h2>
      <p>
        If your order has not yet shipped, email us promptly and we'll cancel it and issue a full refund.
        Once an order is in transit it must follow the standard return process above.
      </p>

      <h2>Promotional codes</h2>
      <p>
        Discounts and pilot codes (WELCOME10, FAMILY15, EARLYBIRD, PILOT) are non-transferable. Refunds
        for orders that used a promotional code are calculated at the discounted price actually paid.
      </p>

      <h2>Questions?</h2>
      <p>
        We're a small, friendly team. If anything feels unclear, please email{" "}
        <a href="mailto:hello@platebuddies.com">hello@platebuddies.com</a> — we read every message.
      </p>
    </LegalPage>
  );
}
